import React, { Component } from "react";
import {
  Card,
  FlatButton,
  CardTitle,
  Dialog,
  TextField,
  Checkbox,
  IconButton,
} from "material-ui";
import searchIcon from "../../images/search_icon.png";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export default class AddUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      user: this.props.user,
      toastOpen: false,
      responseMsg: "",
      address: "",
      userContactErrorText: "",
      userNameErrorText: "",
      userEmailErrorText: "",
      userPasswordErrorText: "",
    };
  }

  componentWillReceiveProps(props) {
    if (props.user && Object.keys(props.user._id).length !== 0) {
      this.setCurrentUser(props.user);
    } else if (props.open) {
      this.showAddUser(props.open, props.user);
    }
  }

  setCurrentUser = (user) => {
    this.setState({ user: user, open: true });
  };

  showAddUser = (open, user) => {
    this.setState({ open: open, user: user });
  };

  handleChange = (address) => {
    let { user } = this.state;
    user.address = address;
    this.setState({ user: user });
  };

  handleSelect = (address) => {
    let { user } = this.state;
    user.address = address;
    this.setState({ user: user });
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  addUser = () => {
    let { user } = this.state;
    var me = this;
    let email = user.email;
    let name = user.name;
    let password = user.password;
    let locked = user.locked;
    let primary_contact = user.primary_contact;

    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }
    let body = {
      email: email,
      name: name,
      password: password,
      locked: locked,
      primary_contact: primary_contact,
    };

    let url = `/api/users/addUser`;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options)
      .then((res) => {
        console.log(res);

        if (res.status >= 200 && res.status < 300) {
          return res.json();
        } else {
          this.notifyFormError(res, "Internal server error.");
          this.setState({ open: false });
          me.props.closeAddUserPopup();
        }
      })
      .then((res) => {
        console.log(res);
        if (res.message == "user already exist") {
          this.notifyFormError(res, "User already exists.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddUserPopup());
        }
      })
      .catch((err) => {
        this.notifyFormError(err, "Internal server error.");
        this.setState({ open: false });
        me.props.closeAddUserPopup();
      });
  };

  updateUser = () => {
    let { user } = this.state;
    let me = this;
    console.log("this.props---11-----", this.props, user);
    let email = user.email;
    let name = user.name;
    let password = user.password;
    let primary_contact = user.primary_contact;
    let locked = user.locked;
    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }

    let body = {
      email: email,
      name: name,
      password: password,
      primary_contact: primary_contact,
      locked,
    };
    let url = `/api/users/update/${user._id}`;
    console.log(url, user._id);
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      console.log(res);

      if (res.status >= 200 && res.status < 300) {
        if (res.json().message == "user already exist") {
          this.notifyFormError(res, "User is already exist.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddUserPopup());
          me.props.closeAddUserPopup();
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
        me.props.closeAddUserPopup();
      }
    });
  };

  updateUserPassword = () => {
    let { user } = this.state;
    let me = this;
    console.log("this.props---11-----", this.props, user);

    let password = user.password;
    let checkValue = this.checkPasswordValidation();
    if (checkValue) {
      return;
    }

    let body = {
      password: password,
    };
    let url = `/api/users/updatePassword/${user._id}`;
    console.log(url, user._id);
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.json().message == "user already exist") {
          this.notifyFormError(res, "User is already exist.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddUserPopup());
          me.props.closeAddUserPopup();
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
        me.props.closeAddUserPopup();
      }
    });
  };

  closeUserModal = () => {
    var me = this;
    this.setState(
      { open: false, userIdErrorText: "", userNameErrorText: "" },
      () => me.props.closeAddUserPopup(),
    );
  };

  onChangeValue = (key, value) => {
    let { user } = this.state;
    if (key == "name") {
      user.name = value;
    } else if (key == "primary_contact") {
      user.primary_contact = value;
    } else if (key == "email") {
      user.email = value;
    } else if (key == "password") {
      user.password = value;
    } else if (key === "locked") {
      user.locked = value;
    }

    this.setState({
      user,
      userContactErrorText: "",
      userNameErrorText: "",
      userEmailErrorText: "",
      userPasswordErrorText: "",
    });
  };

  checkValidation() {
    let { user } = this.state;
    if (user.name == "" || user.name == null) {
      //alert('Please enter clientId');
      this.setState({ userNameErrorText: "Please enter name" });

      return true;
    } else if (user.email == "" || user.email == null) {
      this.setState({ userEmailErrorText: "Please enter user email" });
      return true;
    } else if (
      user._id == "" &&
      (user.password == "" || user.password == null)
    ) {
      this.setState({ userPasswordErrorText: "Please enter password " });
      return true;
    } else if (user.primary_contact == "" || user.primary_contact == null) {
      this.setState({ userContactErrorText: "Please enter user number" });
      return true;
    } else {
      return false;
    }
  }
  checkPasswordValidation() {
    let { user } = this.state;
    if (user.password == "" || user.password == null) {
      this.setState({ userPasswordErrorText: "Please enter password " });
      return true;
    } else {
      return false;
    }
  }
  render() {
    let { open, user } = this.state;
    return (
      <div>
        <Dialog open={open} style={{ zIndex: "9999999" }}>
          <Card className="addUserHeader">
            {user._id != "" ? (
              <CardTitle title="Update User" />
            ) : (
              <CardTitle title="Add User" />
            )}
          </Card>
          {/* <TextField  value={user.userId} disabled={user._id? true : false} floatingLabelText="User Id" style={{width: "22rem", marginTop: "20px"}} onChange={(e) => this.onChangeValue('userId',e.target.value )} errorText= {this.state.userIdErrorText}/> */}
          <TextField
            value={user.name}
            floatingLabelText="User Name"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) => this.onChangeValue("name", e.target.value)}
            errorText={this.state.userNameErrorText}
          />
          <TextField
            value={user.email}
            floatingLabelText="User Email"
            type="email"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) => this.onChangeValue("email", e.target.value)}
            errorText={this.state.userEmailErrorText}
          />

          {user._id == "" && (
            <TextField
              value={user.password}
              floatingLabelText="User Password"
              style={{ width: "22rem", marginLeft: "20px" }}
              onChange={(e) => this.onChangeValue("password", e.target.value)}
              errorText={this.state.userPasswordErrorText}
            />
          )}
          <TextField
            value={user.primary_contact}
            floatingLabelText="Contact Number"
            type="phone"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) =>
              this.onChangeValue("primary_contact", e.target.value)
            }
            errorText={this.state.userContactErrorText}
          />

          <br />

          <div style={{ marginTop: "10px" }}></div>
          <Checkbox
            color="primary"
            label={"Account Locked"}
            checked={user.locked}
            onClick={(e) => {
              this.onChangeValue("locked", !user.locked);
            }}
          />

          {user._id != "" && (
            <div>
              <CardTitle title="Update Password" />
              <TextField
                value={user.password}
                floatingLabelText="User Password"
                style={{ width: "22rem", marginLeft: "20px" }}
                onChange={(e) => this.onChangeValue("password", e.target.value)}
                errorText={this.state.userPasswordErrorText}
              />
              <FlatButton type="submit" onTouchTap={this.updateUserPassword}>
                Update
              </FlatButton>
            </div>
          )}
          <div style={{ float: "right" }}>
            <FlatButton
              className="c-btn__secondary"
              type="cancel"
              onTouchTap={this.closeUserModal}
            >
              Close
            </FlatButton>
            {user._id != "" ? (
              <FlatButton type="submit" onTouchTap={this.updateUser}>
                Update
              </FlatButton>
            ) : (
              <FlatButton type="submit" onTouchTap={this.addUser}>
                Add
              </FlatButton>
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Administration/AddUser.js